export default {
  h1: {
    fontWeight: 700,
    fontSize: 35,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "30px !important",
    },
  },
  h2: {
    fontWeight: 700,
    fontSize: 30,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "25px !important",
    },
  },
  h3: {
    fontWeight: 700,
    fontSize: 24,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "20px !important",
    },
  },
  h4: {
    fontWeight: 400,
    fontSize: 20,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "16px !important",
    },
  },
  h6: {
    fontWeight: 400,
    fontSize: 16,
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "16px !important",
      lineHeight: "1.3",
    },
  },

  body1: {
    fontSize: 12,
    fontWeight: 400,
    fontFamily: "'Heebo', sans-serif",
    "@media(max-width:767px)": {
      fontSize: 14,
    },
  },
  body2: {
    fontSize: 14,
    fontFamily: "'Heebo', sans-serif",
    fontWeight: 400,
  },
};



